import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { DetInitialStep, InitialStep, initialStepType } from "../../types/slices/initialStepType";
import { RootState } from "../store";

const initialState: initialStepType = {
    status: ApiStatus.FETCHED,
    initialSteps: [],
    initialStepSelected: {} as InitialStep,
    detInitialSteps: [],
    errorMessage: undefined
}

const initialStepSlice = createSlice({
    name: 'initialStepSlice',
    initialState,
    reducers: {
        onFetchInitialSteps(state, { payload }: { payload: InitialStep[] }) {
            state.status = ApiStatus.FETCHED
            state.initialSteps = payload
            state.errorMessage = undefined
        },
        onSetSelectedInitialStep(state, { payload }: { payload: InitialStep }) {
            state.initialStepSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onFetchDetInitialStep (state, { payload }: { payload: DetInitialStep[] }) {
            state.status = ApiStatus.FETCHED
            state.detInitialSteps = payload
            state.errorMessage = undefined
        },
    }
})

export const selectInitialStepState = (state: RootState) => state.initialStepSlice
export default initialStepSlice.reducer
export const {
    onFetchInitialSteps,
    onSetSelectedInitialStep,
    changeStatus,
    onFetchDetInitialStep,
} = initialStepSlice.actions